module.exports = __webpack_public_path__ + "au.svg?497744bf6365f271fed917243815ec80";